function fileInputToBlob(file) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()
      reader.onload = function (evt) {
        const metadata = `name: ${file.name}, type: ${file.type}, size: ${file.size}, contents:`
        const contents = evt.target.result
        resolve({
          metadata,
          contents,
        })
      }
      reader.readAsDataURL(file)
    } catch (e) {
      reject(e)
    }
  })
}

function shallowEqual(objA, objB) {
  if (Object.is(objA, objB)) {
    return true
  }
  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false
  }
  const keysA = Object.keys(objA)
  const keysB = Object.keys(objB)
  if (keysA.length !== keysB.length) {
    return false
  }
  for (let i = 0; i < keysA.length; i++) {
    if (
      !hasOwnProperty.call(objB, keysA[i]) ||
      !Object.is(objA[keysA[i]], objB[keysA[i]])
    ) {
      return false
    }
  }
  return true
}

import moment from 'moment'
import { compile as compileFn, match as matchFn } from 'path-to-regexp'

const compileRoute = (route, params = null) => {
  return compileFn(route, { encode: encodeURIComponent })(params || {})
}

const compileTemplate = (route, params = null) => {
  return compileFn(route, {})(params || {})
}

const matchRoute = matchFn

function containsSpecialChars(str) {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
  return specialChars.test(str)
}

function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )
}

const isNumeric = num =>
  (typeof num === 'number' ||
    (typeof num === 'string' &&
      num.trim() !== '' &&
      (parseInt(num) + '').length === num.length)) &&
  !isNaN(num)

const formatListArray = listArr => {
  const formattedData = {}

  listArr &&
    listArr?.forEach(item => {
      const group = item?.group
      const value = item?.value
      if (group == null || group === '' || value == null || value === '') {
        return
      }

      if (!formattedData[group]) {
        formattedData[group] = {
          label: group,
          options: [],
        }
      }

      formattedData[group]?.options?.push({
        value: item.value,
        label: item.label,
      })
    })

  return Object.values(formattedData)
}

function formatSaddleDiscipline(discipline) {
  if (discipline?.includes('_')) {
    return discipline
      ?.split('_') // Split the string into an array of words
      ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' ') // Join the words back into a single string with spaces
  } else {
    // If there is no underscore, just capitalize the first letter of the string
    return discipline?.charAt(0)?.toUpperCase() + discipline?.slice(1)
  }
}

function getSelectedDisciplines(allDisciplines = [], selectedOptions = []) {
  return allDisciplines
    ?.filter(discipline => selectedOptions?.includes(discipline.value))
    ?.map(({ value, label }) => ({ value, label }))
}

const getValuesFunc = newArr => {
  let new_arr = []
  if (Array?.isArray(newArr) && newArr?.length > 0) {
    new_arr = newArr?.map(item => {
      return item?.value
    })
  }
  return new_arr
}

function getByDisciplineFilterValues(a, b) {
  return b
    ?.filter(item => a?.includes(item?.value))
    ?.map(({ label, value }) => ({ label, value }))
}

export const filterColumn = [
  { label: 'Fullfillment Status', value: 'fulfillmentStatus' },
  { label: 'Payment Status', value: 'paymentStatus' },
  { label: 'Order Status', value: 'orderProcessingStatus' },
  { label: 'Delivery Status', value: 'deliveryStatus' },
  { label: 'Date Range', value: 'dateRange' },
  { label: 'Price Range', value: 'priceRange' },
]
export const fulfillmentStatusOptions = [
  { label: 'Fulfilled', value: 'FULFILLED' },
  { label: 'Unfulfilled', value: 'UNFULFILLED' },
  { label: 'Partially Fulfilled', value: 'PARTIALLY_FULFILLED' },
  { label: 'Pending', value: 'PENDING_FULFILLMENT' },
  { label: 'Processing', value: 'IN_PROGRESS' },
  { label: 'On Hold', value: 'ON_HOLD' },
]

export const paymentStatusOptions = [
  { label: 'Paid', value: 'PAID' },
  { label: 'Unpaid', value: 'PENDING' },
  { label: 'Refunded', value: 'REFUNDED' },
  { label: 'Partially Refunded', value: 'PARTIALLY_REFUNDED' },
]

export const orderProcessingStatusOptions = [
  { label: 'New', value: 'OPEN' },
  { label: 'Processing', value: 'IN_PROGRESS' },
  { label: 'Cancelled', value: 'CANCELED' },
  { label: 'On Hold', value: 'ON_HOLD' },
]

export const deliveryStatusOptions = [
  { label: 'Shipped', value: 'IN_TRANSIT' },
  { label: 'Delivered', value: 'DELIVERED' },
  { label: 'Out for Delivery', value: 'OUT_FOR_DELIVERY' },
  { label: 'Attempted Delivery', value: 'ATTEMPTED_DELIVERY' },
  { label: 'Not Delivered', value: 'NOT_DELIVERED' },
]

const formatString = input => {
  let s = input ?? ''

  const u = s.toUpperCase()
  if (u === 'SELL_LIVE') return 'Available'
  if (u === 'SELL_NOT_LIVE') return 'Not Available'

  s = s.replace(/saddlefit/gi, 'Saddle Fit')
  s = s.replace(/_/g, ' ')
  s = s.replace(/([a-z])([A-Z])/g, '$1 $2')
  s = s.replace(/([a-zA-Z])(\d)/g, '$1 $2')
  if (s.trim().toLowerCase() === 'cactussaddlery') return 'Cactus Saddlery'
  s = s.replace(/([a-zA-Z])saddle/gi, '$1 Saddle')

  s = s.replace(/\s+/g, ' ').trim()

  const cap = w => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w)
  s = s
    .split(' ')
    .map(word => word.split('-').map(cap).join('-'))
    .join(' ')

  return s
}

const formatDisplayDate = date => {
  return date ? moment(date).format('MM-DD-YYYY') : ''
}

const seatSizes = [
  { label: '13', value: 13 },
  { label: '13.5', value: 13.5 },
  { label: '14', value: 14 },
  { label: '14.5', value: 14.5 },
  { label: '15', value: 15 },
  { label: '15.5', value: 15.5 },
  { label: '16', value: 16 },
]

const brandNames = [
  { label: 'Cactus Saddlery', value: 'cactus' },
  { label: 'Billy Cook', value: 'billycook' },
]

const orderStatusOptions = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'In Transit', value: 'IN_TRANSIT' },
  { label: 'Delivered', value: 'DELIVERED' },
  { label: 'Cancelled', value: 'CANCELLED' },
]

const horseStatus = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Live', value: 'LIVE' },
  { label: 'Needs Scan', value: 'NEEDS_SCAN' },
]

const updateStatusOptions = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'In Transit', value: 'IN_TRANSIT' },
  { label: 'Delivered', value: 'DELIVERED' },
  { label: 'Cancelled', value: 'CANCELLED' },
]

const generateDateLabels = (start, end) => {
  const startDate = moment(start)
  const endDate = moment(end)
  const days = endDate.diff(startDate, 'days')
  const months = endDate.diff(startDate, 'months')
  const labels = []

  if (days <= 7) {
    // Daily
    for (let d = 0; d <= days; d++) {
      labels.push(moment(startDate).add(d, 'days').format('MMM D'))
    }
  } else if (days <= 30) {
    // Every 3 days
    for (let d = 0; d <= days; d += 3) {
      labels.push(moment(startDate).add(d, 'days').format('MMM D'))
    }
  } else if (days <= 90) {
    // Weekly
    for (let d = 0; d <= days; d += 7) {
      labels.push(moment(startDate).add(d, 'days').format('MMM D'))
    }
  } else if (months <= 6) {
    // Every 2 weeks
    for (let d = 0; d <= days; d += 14) {
      labels.push(moment(startDate).add(d, 'days').format('MMM D'))
    }
  } else if (months <= 12) {
    // Monthly
    let current = moment(startDate).startOf('month')
    while (current.isSameOrBefore(endDate)) {
      labels.push(current.format('MMM YYYY'))
      current.add(1, 'month')
    }
  } else {
    // Every 2nd month or quarterly
    let current = moment(startDate).startOf('month')
    while (current.isSameOrBefore(endDate)) {
      labels.push(current.format('MMM YYYY'))
      current.add(2, 'months')
    }
  }

  return labels
}
function formatName(str = '') {
  return str
    .replace(/-/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

const isRouteAllowed = (pathname, allowedRoutes) => {
  return allowedRoutes.some(route => {
    if (route === pathname) {
      return true
    }

    if (route.includes(':')) {
      if (route.includes('?')) {
        const baseRoute = route.replace(/:\w+\?/g, '')
        const withParamRoute = route.replace(/\?/g, '')

        if (pathname === baseRoute || pathname === baseRoute.slice(0, -1)) {
          return true
        }

        let regexPattern = withParamRoute.replace(/:\w+/g, '[^/]+')
        const regex = new RegExp(`^${regexPattern}$`)
        return regex.test(pathname)
      } else {
        let regexPattern = route.replace(/:\w+/g, '[^/]+')
        const regex = new RegExp(`^${regexPattern}$`)
        return regex.test(pathname)
      }
    }
    return false
  })
}

const makeId14 = () => {
  const ts = Date.now().toString()
  const rand = Math.floor(Math.random() * 10)
  return ts + String(rand)
}



export const toSlug = (raw = '') => {
  let v = String(raw)?.trim()?.toLowerCase();

  v = v?.replace(/^https?:\/\//, '')?.split('/')[0];
  v = v?.replace(/\.myshopify\.com$/i, '');
  v = v?.replace(/\s+/g, '-')?.replace(/[^a-z0-9-]/g, '');

  return v;
}

export const isValidSlug = (slug = '') => /^[a-z0-9][a-z0-9-]*$/?.test(slug)

export {
  compileRoute,
  compileTemplate,
  matchRoute,
  shallowEqual,
  fileInputToBlob,
  containsSpecialChars,
  validateEmail,
  isNumeric,
  formatListArray,
  formatSaddleDiscipline,
  getSelectedDisciplines,
  getValuesFunc,
  getByDisciplineFilterValues,
  formatString,
  seatSizes,
  brandNames,
  orderStatusOptions,
  horseStatus,
  updateStatusOptions,
  formatDisplayDate,
  generateDateLabels,
  formatName,
  isRouteAllowed,
  makeId14,
}
